import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { grey } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/styles';
import device from '../../constants/mediaBreakpoints';

export const CssButton = withStyles({
  root: {
    flex: '1 0 auto',
    flexFlow: 'row nowrap',
    '&:disabled': {
      '&.pay_btn': {
        backgroundColor: grey[400],
        borderColor: grey[200],
        borderRadius: 0,
      },
    },
    '&:hover': {
      '&.pay_btn': {
        backgroundColor: grey[800],
      },
    },
    '&.pay_btn': {
      backgroundColor: grey[900],
      borderRadius: 0,
      color: grey[50],
      cursor: 'pointer',
      position: 'relative',
      padding: '1em',
    },
    '& .pay_amount': {
      position: 'absolute',
      right: '1em',
    },
  },
  label: {
    lineHeight: 1,
    padding: '0.25em 1em',
  },
})(Button);

export const CardArea = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 1 auto;
  
  background-color: var(--background-color);
  max-width: 448px;
  box-shadow: none;
  transition: box-shadow 0.3s ease-out;
  
  }
  @media screen and ${device.mobileL} {
    margin: 0;
    max-width: 100%;
  }
`;
